import { Link } from "react-router-dom";

const servicios = [
  { label: "Persianas", to: "/persianas" },
  { label: "Toldos", to: "/toldos" },
  { label: "Mosquiteras", to: "/mosquiteras" },
  { label: "Presupuesto", to: "/presupuesto" },
  { label: "Sobre nosotros", to: "/sobre-nosotros" },
];

const zonas = [
  { label: "Málaga", slug: "malaga" },
  { label: "Marbella", slug: "marbella" },
  { label: "Fuengirola", slug: "fuengirola" },
  { label: "Torremolinos", slug: "torremolinos" },
  { label: "Benalmádena", slug: "benalmadena" },
  { label: "Mijas", slug: "mijas" },
  { label: "Estepona", slug: "estepona" },
];

export default function Footer() {
  return (
    <footer className="bg-text-primary text-white">
      <div className="max-w-container mx-auto px-4 md:px-6 pt-16 pb-8">
        {/* Main grid */}
        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-10 lg:gap-8">
          {/* Col 1: Logo */}
          <div>
            <Link to="/" className="inline-block font-heading font-bold text-xl text-primary mb-3">
              Persianas Toldos Málaga
            </Link>
            <p className="font-body text-sm text-slate-300 leading-relaxed mb-4">
              Reparación e instalación de persianas, toldos y mosquiteras en Málaga y la Costa del Sol. Técnico propio, sin intermediarios.
            </p>
            <a
              href="https://wa.me/34627213347?text=Hola%2C%20me%20interesa%20info"
              target="_blank"
              rel="noopener noreferrer"
              className="inline-flex items-center gap-2 bg-whatsapp hover:bg-[#128C7E] text-white font-body font-medium text-sm px-4 py-2 rounded-pill transition-colors"
            >
              <i className="ri-whatsapp-line text-base"></i> WhatsApp
            </a>
          </div>

          {/* Col 2: Servicios */}
          <div>
            <h4 className="font-body font-semibold text-base text-white mb-4">Servicios</h4>
            <ul className="flex flex-col gap-2">
              {servicios.map((s) => (
                <li key={s.to}>
                  <Link to={s.to} className="font-body text-sm text-slate-300 hover:text-white transition-colors">
                    {s.label}
                  </Link>
                </li>
              ))}
            </ul>
          </div>

          {/* Col 3: Zonas */}
          <div>
            <h4 className="font-body font-semibold text-base text-white mb-4">Zonas</h4>
            <ul className="flex flex-col gap-2">
              {zonas.map((z) => (
                <li key={z.slug}>
                  <Link to={`/zonas/${z.slug}`} className="font-body text-sm text-slate-300 hover:text-white transition-colors">
                    {z.label}
                  </Link>
                </li>
              ))}
            </ul>
          </div>

          {/* Col 4: Contacto */}
          <div>
            <h4 className="font-body font-semibold text-base text-white mb-4">Contacto</h4>
            <ul className="flex flex-col gap-3">
              <li className="flex items-start gap-2">
                <span className="shrink-0 mt-0.5">☎</span>
                <a href="tel:+34951120770" className="font-body text-sm text-slate-300 hover:text-white transition-colors">
                  951 12 07 70
                </a>
              </li>
              <li className="flex items-start gap-2">
                <span className="shrink-0 mt-0.5">💬</span>
                <a
                  href="https://wa.me/34627213347?text=Hola%2C%20me%20interesa%20info"
                  target="_blank"
                  rel="noopener noreferrer"
                  className="font-body text-sm text-slate-300 hover:text-white transition-colors"
                >
                  WhatsApp 627 21 33 47
                </a>
              </li>
              <li className="flex items-start gap-2">
                <span className="shrink-0 mt-0.5">✉</span>
                <a href="mailto:info@persianas-toldos-malaga.es" className="font-body text-sm text-slate-300 hover:text-white transition-colors">
                  info@persianas-toldos-malaga.es
                </a>
              </li>
              <li className="flex items-start gap-2">
                <span className="shrink-0 mt-0.5">📍</span>
                <span className="font-body text-sm text-slate-300">
                  Calle Pacífico 54, San Andrés, 29003 Málaga
                </span>
              </li>
            </ul>
          </div>
        </div>

        {/* Bottom bar */}
        <div className="mt-12 pt-6 border-t border-slate-700 flex flex-col sm:flex-row items-center justify-between gap-4">
          <div className="flex flex-col gap-1 text-center sm:text-left">
            <p className="font-body text-[13px] text-slate-400">
              © 2026 Persianas Toldos Málaga · CIF: B93847562 · Calle Pacífico 54, 29003 Málaga
            </p>
            <p className="font-body text-[12px] text-slate-500">
              Horario: Lun-Vie 8:00-20:00 · Sáb 9:00-14:00 · Dom cerrado · Empresa inscrita en el Registro Mercantil de Málaga
            </p>
          </div>
          <div className="flex items-center gap-4 flex-wrap justify-center">
            <Link to="/aviso-legal" className="font-body text-[13px] text-slate-400 hover:text-white underline transition-colors">
              Aviso Legal
            </Link>
            <Link to="/politica-privacidad" className="font-body text-[13px] text-slate-400 hover:text-white underline transition-colors">
              Política de Privacidad
            </Link>
            <Link to="/politica-cookies" className="font-body text-[13px] text-slate-400 hover:text-white underline transition-colors">
              Política de Cookies
            </Link>
          </div>
        </div>
      </div>
    </footer>
  );
}